import { render, staticRenderFns } from "./imgS.vue?vue&type=template&id=d266d398"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d266d398')) {
      api.createRecord('d266d398', component.options)
    } else {
      api.reload('d266d398', component.options)
    }
    module.hot.accept("./imgS.vue?vue&type=template&id=d266d398", function () {
      api.rerender('d266d398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgS.vue"
export default component.exports